import script from "./DisbursementsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementsTable.vue?vue&type=script&setup=true&lang=ts"

import "./DisbursementsTable.vue?vue&type=style&index=0&id=aa97b062&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa97b062"]])

export default __exports__